export const ENABLE_MEETINGS_NAVIGATION = JSON.parse(import.meta.env.VITE_ENABLE_MEETINGS_NAVIGATION)
export const RECENTLY_VISITED_LIST_SIZE = JSON.parse(import.meta.env.VITE_RECENTLY_VISITED_LIST_SIZE)
export const ENFORCE_TEAMS_LAYOUT = JSON.parse(import.meta.env.VITE_ENFORCE_TEAMS_LAYOUT)
export const ENABLE_PAYWALL = JSON.parse(import.meta.env.VITE_ENABLE_PAYWALL)
export const SHOW_PROJECT_IN_ITEMS_CELL = JSON.parse(import.meta.env.VITE_SHOW_PROJECT_IN_ITEMS_CELL)
export const INACTIVIY_LOGOUT = JSON.parse(import.meta.env.VITE_ENABLE_INACTIVIY_LOGOUT)
export const SHOW_REACT_QUERY_DEVTOOL = JSON.parse(import.meta.env.VITE_SHOW_REACT_QUERY_DEVTOOLS)
